import './Modal.css'
import { styled, Box } from '@mui/system';
import ModalUnstyled from '@mui/base/ModalUnstyled';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { IconButton } from '@mui/material';
import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface ModalProps {
    isOpen: boolean,
    onClose: ((event?: {}, reason?: "backdropClick" | "escapeKeyDown") => void)
    childComponent: {},
    message?: boolean
}

const StyledModal = styled(ModalUnstyled)`
  position: fixed;
  z-index: 999 !important;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;  
  outline: none;
  box-shadow: none;
`;

export const Modal = ({ isOpen, onClose, childComponent }: ModalProps) => {


    return (

        <StyledModal
            aria-labelledby="unstyled-modal-title"
            aria-describedby="unstyled-modal-description"
            open={isOpen}
            onClose={onClose}
            hideBackdrop={true}
            style={{boxShadow:"none", outline: "none"}}
        >
            <Box className={"w-modal"}>
                <div className="w-modal-header ">
                    <div className="w-modal-close">
                        <IconButton onClick={(e) => {onClose(e, "backdropClick")}} aria-label="close">
                            <FontAwesomeIcon color='black' icon={faClose} />
                        </IconButton>
                    </div>
                </div>
                <div className="w-modal-body">
                    <>
                        {childComponent}
                    </>
                </div>
            </Box>
        </StyledModal>
    )
}